module.exports = __webpack_public_path__ + "static/swiss-721-bt-70631-b96d45d3a75b7b1da302b573cae869f1.ttf";